import { SimpleDialog } from '../components/modals/SimpleDialog';
import Typography from '../components/typography/Typography';
import { Box, IconButton } from '@mui/material';
import { FC } from 'react';
import { Button } from 'src/shared/components/index';
import { CustomDeleteDialogProps } from './Interface/deleteModal';
import { I18N } from '../constants/constants';
import { useTranslation } from 'react-i18next';
import DeleteIcon from '@mui/icons-material/Delete';
import { useTheme } from '@mui/material';

const CustomDeleteModal: FC<CustomDeleteDialogProps> = (props) => {
  const { open, title, name, details, subtitle, onDelete, onClose, nameKey } =
    props;
  const { t } = useTranslation(I18N.DEFAULT);
  const theme = useTheme();
  return (
    <>
      <SimpleDialog
        open={open}
        model_title={
          <Box className="ml-20 mt-20">
            <Box
              className="delete-modal-headerIcon"
              sx={{
                color: theme.general.deleteModalIcon,
                backgroundColor: theme.general.deleteModalIconBackgroundBolor
              }}
            >
              <DeleteIcon />
            </Box>
            <Box className="mt-25">
              <Typography variant="h3" fontWeight="bold">
                {title}
              </Typography>
            </Box>
          </Box>
        }
        model_content={
          <Box className="ml-20">
            <Typography variant="h4">
              {t('dialog.action.delete')} :{' '}
              {nameKey && details ? details[nameKey] : name}
            </Typography>
            <Typography
              className="mt-24 color-delete-modal-subtitle"
              variant="body2"
              fontWeight="bold"
            >
              {subtitle}
            </Typography>
          </Box>
        }
        model_actions={
          <Box className="mb-15 mr-15">
            <Button btnText={t('dialog.action.cancel')} onClick={onClose} />
            <Button
              btnText={t('dialog.action.delete')}
              variant={'contained'}
              onClick={onDelete}
              className="ml-20"
            />
          </Box>
        }
        customClass="editFormPopup"
        onClose={onClose}
      />
    </>
  );
};

export default CustomDeleteModal;
